import { MaterialConfiguration } from './material-configuration';
import { LinkActions } from 'app/core/components/workflow-new/common/base-card-configuration';


export class VideoCardConfiguration extends MaterialConfiguration {
    constructor(course: any) {
        super();
        this.tagType = 'material';
        this.thumbnail = course.smallImageUri || 'https://itpx-branded-portal-dev.s3.amazonaws.com/video.png';
        this.classType = 'Video';
        this.subtitle = 'branded.portal.courses.assignment.material.video.subtitle';
        this.expired = !course.enabled;
        this.multiContent = course.contents.length > 1;
        this.clickable = !this.expired;
        this.target = ['video', course.contents[0].id];
        this.action = LinkActions.REDIRECT;
        this.links = [{
            disabled: this.expired,
            tooltip: this.expired ? 'branded.portal.courses.assignment.material.video.expired.tooltip' : null,
            url: this.expired ? [] : ['video', course.contents[0].id],
            text: 'branded.portal.courses.assignment.video.toplayer.text',
            type: LinkActions.REDIRECT,
        }]
    }
}



// WEBPACK FOOTER //
// ./src/app/core/components/workflow-new/material/configurations/video-card-configuration.ts